module.exports = __webpack_public_path__ + "static/media/FullSizeRender.c5f1d59b.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/emptyState/FullSizeRender.png
// module id = 27
// module chunks = 0